module.exports = "<button myToggleFullscreen=\"\">\n    <img [src]=\"isFullscreen ? '/img/exit-fullscreen.png' : '/img/enter-fullscreen.png'\"/>\n</button>"